<template>
  <div class="RouteOrderEdit">
    <fy-form
      :model="order_info"
      :rules="rules"
      class="fy-form-route_order_contract"
      ref="form"
      v-if="!isInit"
    >
      <div class="order_success_content" style="border: none; margin: 0;">
        <amount-detail
          :advanceList="advanceList"
          :favorableList="favorableList"
          :orderAdditionalCosts="orderAdditionalCosts"
          :orderInfo="order_info"
          :orderNums="orderNums"
          :ticketPrices="ticketPrices"
          :ticketType="ticketType"
        ></amount-detail>
      </div>
      <div class="contacts_info">
        <div class="edit_order_line">
          <i>联系人信息</i>
        </div>
        <fy-form-item
          :label="fields.contact_person.field_name"
          :prop="fields.contact_person.field_enname"
        >
          <fy-input
            :placeholder="fields.contact_person.field_placeholder"
            type="text"
            v-model.trim="order_info.contact_person"
          ></fy-input>
        </fy-form-item>

        <fy-form-item
          :label="fields.contact_tel.field_name"
          :prop="fields.contact_tel.field_enname"
        >
          <fy-input
            :placeholder="fields.contact_tel.field_placeholder"
            type="text"
            v-model.trim="order_info.contact_tel"
          ></fy-input>
        </fy-form-item>
        <!-- <div class="edit_order_line">
          <i>固话</i>
          <input type="text" name="contact_tel2" v-model.trim="order_info.contact_tel2" placeholder="非必填">
        </div>-->
        <div class="edit_order_line">
          <i>邮箱</i>
          <input name="email" placeholder="非必填" type="text" v-model.trim="order_info.email">
        </div>
      </div>

      <div class="contacts_info" id="pedestrians">
        <div class="edit_order_line">
          <i>办签人信息</i>
        </div>
        <div class="edit_order_line edit_sign_line" v-for="(name_info, index) in name_lists">
          <i>{{name_info.ticket_type}}</i>
          <i>{{name_info.name}}</i>
          <a @click="editName(name_info.name_list_info_id)" href="javascript:void(0);">
            <em class="contacts_info_p">编辑办签人</em>
          </a>
        </div>
      </div>

      <div class="contacts_info">
        <div class="contacts_info_line">
          <span>订单备注</span>
          <div class="contacts_info_input contacts_info_input_textarea">
            <textarea name="remark" placeholder="请输入" v-model.trim="order_info.remark" wrap="hard"></textarea>
          </div>
        </div>
      </div>
      <div class="chose_number_button">
        <span id="back" name="back">
          <input @click="back" name="back_order" type="button" value="返 回">
        </span>
        <span id="next" name="next">
          <input @click="edit" name="edit_order" type="button" value="编辑订单">
        </span>
      </div>
    </fy-form>
  </div>
</template>

<script>
import { amountDetail } from './../components/'
export default {
  name: 'RouteOrderEdit',
  components: { amountDetail },
  data () {
    return {
      isInit: true, //判断页面初始化时的异步加载是否完成（由于父子组件间异步传数据，有可能子组件mounted阶段时异步加载还未完成）
      income: '',
      order_id: 0,
      fields: {},
      rules: {},
      order_info: {},
      name_lists: [],
      plan_info: {},
      orderNums: [],
      ticketType: [],
      ticketPrices: [],
      orderAdditionalCosts: [],
      advanceList: [],
      favorableList: [],
    }
  },
  created () {
    this.order_id = this.$route.query.order_id
    this.income = this.$route.query.income
    this.$pageField.init(this, 'fields', 'routeOrderContact').then(res => {
      this.isInit = false //异步加载完成后设置为false
      console.log(res)
    })
    this.getInfo()
    if (this.income) {
      this.$sessionStorageUtil.set('income', this.income)
    }

  },
  methods: {
    getInfo () {
      if (this.income) {
        let url = 'order_info/order_detail/' + this.order_id
        this.$myGet(url, {}).then(res => {
          if (res.status == 200) {
            this.order_info = res.response.data.orderInfo
            this.plan_info = res.response.data.planInfo
            this.name_lists = res.response.data.nameListInfoList
            this.$sessionStorageUtil.set('name_lists', this.name_lists)
            this.$sessionStorageUtil.set('plan_info', this.plan_info)

            this.orderNums = res.response.data.orderNums
            this.ticketType = res.response.data.ticketTypes
            this.ticketPrices = res.response.data.ticketPrices
            this.orderAdditionalCosts = res.response.data.orderAdditionalCosts
            this.advanceList = res.response.data.advanceList
            this.favorableList = res.response.data.favorableList
          } else {
            this.$msg('服务器异常，请重试或联系管理员!', 'error')
          }
        })
          .catch(err => {
            console.log('err:' + err)
          })
      } else {
        this.name_lists = this.$sessionStorageUtil.get('name_lists')
        this.order_info = this.$sessionStorageUtil.get('order_info')
        this.plan_info = this.$sessionStorageUtil.get('plan_info')
      }


    },
    back () {
      if (this.$sessionStorageUtil.get('income') == 'list') {
        this.$pushByName('agentOrderList')
      } else {
        this.$pushByName('agentOrderDetail', { order_id: this.order_id })
      }
      this.$sessionStorageUtil.remove('income')
    },
    edit () {
      this.$sessionStorageUtil.set('order_info', this.order_info)
      var loading = this.$loadingIndicator.eleOpen()
      let url = 'order_route/order_edit/'
      let param = { order_info: this.order_info, name_list_infos: this.name_lists }
      this.$myPut(url, param).then(res => {
        var result = res.response.data.result
        if (result.code > 0) {
          this.$msg(result.msg, 'info', 3000)
        } else {
          this.$msg(result.msg, 'err', 3000)
        }
        console.log('res:' + res)
        loading.close();
      }).catch(err => {
        console.log('err:' + err)
        this.$msg('订单更新失败！', 'err', 3000)
        loading.close();
      })
    },
    editName (nameListId) {
      this.$sessionStorageUtil.set('order_info', this.order_info)
      this.$pushByName('routeOrderNameList', { name_list_id: nameListId, plan_id: this.plan_info.route_plan_id, source: this.plan_info.source })
    }
  },
}
</script>

<style lang="" scoped>
@import '../../../assets/css/pages/agent/second_phase.css';
.RouteOrderEdit {
  width: 500px;
  margin: 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/agent/route/routeOrderEdit.vue